import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';

import { FlightTimeRequestInterface } from '@interfaces/air-leg-calculator/flight-time-request.interface';
import { FlightTimeResponseInterface } from '@interfaces/air-leg-calculator/flight-time-response.interface';
import { AircraftModelsResponseInterface } from '@interfaces/air-leg-calculator/aircraft-models-response.interface';
import { AircraftMappingResponseInterface } from '@interfaces/air-leg-calculator/aircraft-mapping-response.interface';

@Injectable({ providedIn: 'root' })
export class AirLegCalculatorHttpService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = `${environment.apiHostV2}/air-leg-calculator`;

  /**
   * Fetches available aircraft models from Avia Pages via the backend.
   */
  getAircraftModels(): Observable<AircraftModelsResponseInterface> {
    return this.httpClient.get<AircraftModelsResponseInterface>(`${this.baseUrl}/aircraft-models`);
  }

  /**
   * Fetches aircraft category-to-model mappings used for flight-time calculation.
   */
  getAircraftMapping(): Observable<AircraftMappingResponseInterface> {
    return this.httpClient.get<AircraftMappingResponseInterface>(`${this.baseUrl}/aircraft-mapping`);
  }

  /**
   * Calculates flight time and planned leg duration for the given route, aircraft model, and start time.
   */
  calculateFlightTime(payload: FlightTimeRequestInterface): Observable<FlightTimeResponseInterface> {
    return this.httpClient.post<FlightTimeResponseInterface>(`${this.baseUrl}/flight-time`, payload);
  }
}
